<title mat-dialog-title>Добавление модуля</title>
<button class="mat-raised-button mat-primary" (click)="file_upload()" >Загрузить файл</button><label class="result-label">{{ resultMessage }}</label>
<mat-form-field [formGroup]="form" appearance="fill">
    <mat-label>Уровень доступа</mat-label>
    <mat-select formControlName="security_level">
        <mat-option *ngFor="let security_level of security_levels" [value]="security_level">{{security_level.ShortTitle}}</mat-option>
    </mat-select>
</mat-form-field>
<br>

<mat-form-field [formGroup]="form" class="example-full-width">
    <mat-label>Краткое описание</mat-label>
    <input name="st_name" class="form-control" minlenght=1 formControlName="short_title" matInput placeholder="Short title" value="" required>
</mat-form-field>

<br>

<mat-form-field [formGroup]="form" class="example-full-width">
    <mat-label>Описание</mat-label>
    <textarea cdkTextareaAutosize formControlName="description" matInput placeholder="Description" value="" required></textarea>
</mat-form-field>
<br>


<mat-form-field [formGroup]="form" class="example-full-width">
    <mat-label>Командная строка</mat-label>
    <input formControlName="commandline" matInput placeholder="CommandLine" value="" required>
</mat-form-field>
<br>

<mat-form-field [formGroup]="form" class="example-full-width">
    <mat-label>Параметры запуска</mat-label>
    <input formControlName="inputparametrs" matInput placeholder="InputParametrs" value="" required>
</mat-form-field>
<br>




<mat-dialog-actions>
    <button style="margin-right:5.5rem;" class="mat-raised-button" (click)="close()">Закрыть</button>
    <button class="mat-raised-button mat-primary" (click)="save()" [disabled]="form.get('security_level').value.ID === -1 || form.get('short_title').value.length < 1 ">Сохранить</button>
</mat-dialog-actions>